import React from 'react';
import { interpolateElements } from 'i18n/format';

// A translated string with its placeholders filled by elements, for sentences
// that name a player with UserComponent: "set by %s". Follows the same rules as
// __(): %s in order, %1$s by number (a translation may reorder them), %% for %.
export default function TextWithElements({ text, elements = [] }) {
	return <>{interpolateElements(text, elements)}</>;
}
